<template lang="pug">
  v-chip(
    label
    outline
    :color="statusColor"
  )
    span.text-none {{ statusText }}
</template>

<script>
import {
  DONE_STATUS,
  DONE_WITH_ERRORS_STATUS,
  PENDING_STATUS,
  FAILED_STATUS,
  IMPORT_CONTACTS_STATUS_LABELS,
} from '@/Contacts/components/import/config/import-contacts-reports';

export default {
  props: {
    status: {
      type: String,
    },
  },
  computed: {
    statusColor() {
      switch (this.status) {
        case DONE_STATUS:
          return 'green';
        case DONE_WITH_ERRORS_STATUS:
          return '#FFA500';
        case FAILED_STATUS:
          return 'red'
        case PENDING_STATUS:
          return 'blue';
      }
    },
    statusText() {
      return IMPORT_CONTACTS_STATUS_LABELS[this.status];
    },
  },
};
</script>
